import { createFileRoute } from '@tanstack/react-router';
import {
  billingListScreen,
  billingSearch,
  loadBillingMessages,
  loadBillingScreens,
} from '@/modules/billing/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/gestao-carteira/cobrancas/')({
  validateSearch: billingSearch,
  staticData: { screen: billingListScreen },
  loader: () => loadBillingMessages(),
  component: lazyScreen(loadBillingScreens, 'BillingListRouteScreen'),
});
